import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/FipiPublication.css";   // IMPORTANT: use same css

import Finance from "../assets/images/i/Finance  Taxation.jpg";
import Upstream from "../assets/images/i/Upstream.jpg";
import Downstream from "../assets/images/i/Downstream.jpg";
import NaturalGas from "../assets/images/i/Natural Gas.jpg";

const Recommendation = () => {
  const navigate = useNavigate();

  return (
    <div className="fipi-publication"> {/* SAME WRAPPER */}

      {/* ===== HEADER / BACK BUTTON ===== */}
      <div className="fipi-publication-header">
        <button className="clear-filters-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>
      </div>

      {/* ===== CARD GRID ===== */}
      <div className="fipi-publication-grid">

        {/* Finance & Taxation */}
        <div
          className="card"
          onClick={() =>
            window.open("https://www.fipi.org.in/recomm-finance.php", "_blank")
          }
        >
          <img src={Finance} alt="Finance and Taxation" />
          <h3>Finance and Taxation</h3>
          <div className="card-link">
            <a href="#!" onClick={(e) => e.preventDefault()}>
              Explore More Contents
            </a>
          </div>
        </div>

        {/* Upstream */}
        <div
          className="card"
          onClick={() =>
            window.open("https://www.fipi.org.in/recomm-upstream.php", "_blank")
          }
        >
          <img src={Upstream} alt="Upstream" />
          <h3>Upstream</h3>
          <div className="card-link">
            <a href="#!" onClick={(e) => e.preventDefault()}>
              Explore More Contents
            </a>
          </div>
        </div>

        {/* Downstream */}
        <div
          className="card"
          onClick={() =>
            window.open("https://www.fipi.org.in/recomm-downstream.php", "_blank")
          }
        >
          <img src={Downstream} alt="Downstream" />
          <h3>Downstream</h3>
          <div className="card-link">
            <a href="#!" onClick={(e) => e.preventDefault()}>
              Explore More Contents
            </a>
          </div>
        </div>

        {/* Natural Gas */}
        <div
          className="card"
          onClick={() =>
            window.open("https://www.fipi.org.in/recomm-naturalgas.php", "_blank")
          }
        >
          <img src={NaturalGas} alt="Natural Gas" />
          <h3>Natural Gas</h3>
          <div className="card-link">
            <a href="#!" onClick={(e) => e.preventDefault()}>
              Explore More Contents
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Recommendation;
